// extracted by mini-css-extract-plugin
export default {"container":"MarketStateBadge_container__OzpCf"};